export const experienceData = [
    {
        id: 1,
        company: 'CODEPLATEAU TECHNOLOGY SOLUTIONS,PUNE',
        jobtitle: 'React Js Developer',
        startYear: '06/2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'ALAGZOO SOFTWARE SERVICES,HYDERABAD',
        jobtitle: 'Frontend Developer',
        startYear: '02/2022',
        endYear: '05/2022'
    },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]